const state = {}

const getters = {
  searchable: (state) => state.searchable || ['account', 'pickup', 'carrier', 'profile', 'ratecard', 'consignment', 'team'],
  isShowPeek: (state) => state.isShowPeek,
  isBasicFilter: (state) => !state.isAdvancedFilter,
  isAdvancedFilter: (state) => state.isAdvancedFilter,
  isExperimentalFilter: (state) => state.isExperimentalFilter,
  isNewSearch: (state) => state.isNewSearch || false,
  resultsPerPage: (state) => state.resultsPerPage || 20,
  storeFilters: (state) => state.storeFilters || false
}

const mutations = {
  //
}

const actions = {
  //
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
